import { connect } from "react-redux";
import BookingInformation from "app/pages/.shared/BookingInformation/BookingInformation";

const mapStateToProps = state => {
	const offerType = state.booking?.offer?.type;
	const ficheProduit = state.ficheProduit;
	return {
		dvaf: state.documents.dvaf[offerType] ? state.documents.dvaf[offerType] : undefined,
		usefulInformations: ficheProduit.usefulInformations,
		contractRemarks: state.payment.contractRemarks,
	};
};

export default connect(mapStateToProps)(BookingInformation);
